import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function CustomDialog({
  open,
  handleClose,
  MainText,
  AgreeText,
  CloseText,
  onSubmit,
}) {
  return (
    <React.Fragment>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: '#222',

            color: 'white',
          },
        }}
        open={open}
        keepMounted
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogTitle id='alert-dialog-slide-title'>{MainText}</DialogTitle>
        <DialogActions>
          <Button onClick={onSubmit} color='inherit'>
            {AgreeText}
          </Button>
          <Button onClick={handleClose} color='inherit'>
            {CloseText}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
